import { render, staticRenderFns } from "./AnimatedBackground.vue?vue&type=template&id=e0830622&"
import script from "./AnimatedBackground.vue?vue&type=script&lang=js&"
export * from "./AnimatedBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports